import React from 'react';

function PrimarySmallButton({ name,showLeadingIcon, showTrailingIcon }) {
    return (
        <>
            <button className='bg-black py-12 text-12 font-semibold text-white px-48 border-2 border-white shadow-md cursor-pointer'>
                {showLeadingIcon && (
                    <div>
                        {showLeadingIcon}
                    </div>
                )}
                <div>
                    {name}
                </div>
                {showTrailingIcon && (
                    <div>
                        {showTrailingIcon}
                    </div>
                )}
            </button>
        </>
    )
}

export default PrimarySmallButton;